/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_WatermarkedInputs */

const en_field_watermarked = /** @type {(inputs: Field_WatermarkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Watermarked Preview?`)
};

const es_field_watermarked = /** @type {(inputs: Field_WatermarkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Vista previa con marca de agua?`)
};

const fr_field_watermarked = /** @type {(inputs: Field_WatermarkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aperçu en filigrane ?`)
};

const de_field_watermarked = /** @type {(inputs: Field_WatermarkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschau mit Wasserzeichen?`)
};

const ja_field_watermarked = /** @type {(inputs: Field_WatermarkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`透かし入りプレビューか`)
};

const zh_field_watermarked = /** @type {(inputs: Field_WatermarkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`带水印的预览图？`)
};

const ar_field_watermarked = /** @type {(inputs: Field_WatermarkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معاينة بعلامة مائية؟`)
};

const id_field_watermarked = /** @type {(inputs: Field_WatermarkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pratinjau Ber-Watermark?`)
};

const it_field_watermarked = /** @type {(inputs: Field_WatermarkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteprima con Filigrana?`)
};

const ru_field_watermarked = /** @type {(inputs: Field_WatermarkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Превью с водяным знаком?`)
};

const pt_field_watermarked = /** @type {(inputs: Field_WatermarkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-visualização com Marca d'Água?`)
};

const ko_field_watermarked = /** @type {(inputs: Field_WatermarkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`워터마크 프리뷰 여부`)
};

/**
* | output |
* | --- |
* | "Watermarked Preview?" |
*
* @param {Field_WatermarkedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_watermarked = /** @type {((inputs?: Field_WatermarkedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_WatermarkedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_watermarked(inputs)
	if (locale === "es") return es_field_watermarked(inputs)
	if (locale === "fr") return fr_field_watermarked(inputs)
	if (locale === "de") return de_field_watermarked(inputs)
	if (locale === "ja") return ja_field_watermarked(inputs)
	if (locale === "zh") return zh_field_watermarked(inputs)
	if (locale === "ar") return ar_field_watermarked(inputs)
	if (locale === "id") return id_field_watermarked(inputs)
	if (locale === "it") return it_field_watermarked(inputs)
	if (locale === "ru") return ru_field_watermarked(inputs)
	if (locale === "pt") return pt_field_watermarked(inputs)
	return ko_field_watermarked(inputs)
});